import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Logo = ({ siteName, logoImageURL, logoURL }) => {
    return (_jsxs("a", { href: logoURL, className: "header__logo", children: [_jsx("img", { src: logoImageURL, className: "header__logo-img", alt: "logo" }), _jsx("div", { className: "header__logo-text", children: siteName })] }));
};
export default Logo;
